import moment from "moment";
import { toTagIdPayload } from "./customer/customerTags";
import { effectiveModeFor } from "../activityKind";
import { announceQuoteVersionBooked } from "./quotation/followupRevision";
import { checkBeforeQuoteSave } from "./quotation/anomalyConfirm";

export function saveSupportCase (that, from) {
  if (that.supportCase && that.supportCase.status && that.supportCase.active && that.supportCase.type && that.supportCase.description && that.supportCase.details &&  that.attachment.attachId) {
    that.supportCase = {...that.supportCase,screenshot: that.attachment.attachId, status: that.supportCase.status.name, type: that.supportCase.type.code}
    that.supportCaseService.saveSupportCase(that.supportCase)
    .then(res => {
      that.sendingRequest = false
      that.submitted = false
      that.$emit("close");
      that.showMsg()
      that.supportCase = {
          type: null,
          description: null,
          details: null,
          resolution: null,
          status: {
              id: 0,
              name: 'NEW'
          },
          active: true,
          screenshot: null,
          loggedInUser: null
      }

      
    })
    .catch(e => {
      that.sendingRequest = false
      that.submitted = false
      that.supportCase = {
          type: null,
          description: null,
          details: null,
          resolution: null,
          status: {
              id: 0,
              name: 'NEW'
          },
          active: true,
          screenshot: null,
          loggedInUser: null
      }
      if (e.response && e.response.status !== 200)                
        that.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error while adding SupportCase",
          life: 5000,
        })

        that.$emit("close");
    })

  } else {
    that.sendingRequest = false


    
    try {
      if (!that.supportCase.status) {
        document.getElementById('status').focus()
      }
      else if (!that.supportCase.active) {
        document.getElementById('active').focus()
      }
      else if (!that.supportCase.details) {
        document.getElementById('salesExec').focus()
      }
      else if (!that.supportCase.description) {
        document.getElementById('description').focus()
      }
      else if (!that.supportCase.details) {
        document.getElementById('details').focus()
      }
      else if (!that.supportCase.type) {
        document.getElementById('type').focus()
      }
    } catch(e) {
      
    }
  }
}


export function opportunityRequest (that, opportunity, from) {

  if (!opportunity.country)
    opportunity.country = 'UK'

  if (
    opportunity.oppDescription &&
    opportunity.address1 &&
    opportunity.address2 &&
    opportunity.address3 &&
    opportunity.cityTown &&
    opportunity.postCode &&
    opportunity.customer &&
    opportunity.contact &&
    // opportunity.country &&
    opportunity.mbpBranch &&
    (opportunity.mbpBranch.branchId || opportunity.mbpBranch.id) &&
    opportunity.phoneNo &&
    opportunity.email &&
    // opportunity.salesExec &&
    // opportunity.salesExec.salesExecId &&
    opportunity.projectType &&
    opportunity.dateReceived
  ) {
    var realOpportunity = {...opportunity}
    
    var branchId = realOpportunity?.mbpBranch?.branchId ? realOpportunity?.mbpBranch?.branchId: realOpportunity?.mbpBranch?.id;

    let a = moment(realOpportunity.dateReceived).format("DD/MM/YYYY HH:mm");
    if (a != 'Invalid date') {
      realOpportunity.dateReceivedMoment = a
    } else {
      realOpportunity.dateReceivedMoment = realOpportunity.dateReceived
    }
    
    realOpportunity.mbpBranch = realOpportunity.mbpBranch
      ? branchId
      : null;
    realOpportunity.customer = realOpportunity.customer
      ? realOpportunity.customer.customerId
      : null;
    realOpportunity.contact = realOpportunity.contact
      ? realOpportunity.contact.contactId
      : null;
    realOpportunity.opportunityType = realOpportunity.opportunityType
      ? realOpportunity.opportunityType.id
      : null;
    realOpportunity.opportunityStatus = realOpportunity.opportunityStatus
      ? realOpportunity.opportunityStatus.id
      : null;
    realOpportunity.projectType = realOpportunity.projectType
      ? realOpportunity.projectType.id
      : null;

    if(realOpportunity.salesExec) {
      if(realOpportunity.salesExec.salesExecId)
      realOpportunity.salesExec = realOpportunity.salesExec.salesExecId
      else if(realOpportunity.salesExec.id)
      realOpportunity.salesExec = realOpportunity.salesExec.id
      else
      realOpportunity.salesExec = null
    }

    realOpportunity.cityTown = realOpportunity.cityTown
      ? realOpportunity.cityTown.id
      : null;
  
    if (realOpportunity.productType && realOpportunity.productType.id)
      realOpportunity.productType = realOpportunity.productType.id
      
    if (realOpportunity.region && realOpportunity.region.id)
      realOpportunity.region = realOpportunity.region.id

    if (!realOpportunity.address4) {
      realOpportunity.address4 = null
    }

    if (realOpportunity.oppDescription)
      realOpportunity.oppDescription = realOpportunity.oppDescription.toUpperCase()
    if (realOpportunity.address1)
      realOpportunity.address1 = realOpportunity.address1.toUpperCase()
    if (realOpportunity.address2)
      realOpportunity.address2 = realOpportunity.address2.toUpperCase()
    if (realOpportunity.address3)
      realOpportunity.address3 = realOpportunity.address3.toUpperCase()
    if (realOpportunity.address4)
      realOpportunity.address4 = realOpportunity.address4.toUpperCase()
    if (realOpportunity.postCode)
      realOpportunity.postCode = realOpportunity.postCode.toUpperCase()
      

    if (realOpportunity.receivedDate) {
      a = moment(realOpportunity.receivedDate).format("DD/MM/YYYY");
      if (a != "Invalid date") {
        realOpportunity.receivedDate = a;
      } else {
        realOpportunity.receivedDate = realOpportunity.receivedDate;
      }
    } else {
      realOpportunity.receivedDate = null
    }
  
    
  
    if (realOpportunity.oppId) {
      
      delete realOpportunity.weblink
      delete realOpportunity.quotation
      delete realOpportunity.createdBy
      delete realOpportunity.updatedBy
  
      that.opportunityService
        .updateOpportunity(realOpportunity.oppId, realOpportunity)
        .then((response) => {
          that.sendingRequest = false

          that.$toast.add({
            severity: "success",
            summary: response.data,
            detail: "Opportunity Updated",
            life: 5000,
          });
  
          if (from === 'OpportunityForm.vue') {
            that.$emit("save", {
              opportunity: realOpportunity, 
              customer: that.selectedCustomer, 
              duplicateInfo: that.duplicateInfo
            });
            that.$emit("close");
          }
          
        })
        .catch((e) => {
          that.sendingRequest = false
          
          
          if (e.response && e.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating enquiry",
              life: 5000,
            })
        });
    } else {

      // Tell the parent a create is under way so it can show the two-line progress popup.
      if (from === 'OpportunityForm.vue') {
        that.$emit("saving")
      }

      that.opportunityService
        .saveOpportunity(realOpportunity)
        .then(response => {
          that.sendingRequest = false
          
          
          realOpportunity = response.data;
          
          that.$toast.add({
            severity: "success",
            summary: "New Opportunity Saved",
            detail: `new Opportunity was saved successfully, Quote No generated : ${realOpportunity.sQuoteNo}`,
            life: 7000,
          });
          
          if (from === 'OpportunityForm.vue') {
            that.$emit("save", {
              opportunity: realOpportunity, 
              customer: that.selectedCustomer, 
              duplicateInfo: that.duplicateInfo,
              sQuoteNo: realOpportunity.sQuoteNo,
              // 'SENT' | 'SKIPPED' | 'FAILED' — the email is sent AFTER the enquiry is
              // committed, so a failure here never means the enquiry was lost.
              emailStatus: realOpportunity.emailStatus
            });
            that.$emit("close");
          }
          
        })
        .catch((e) => {
          
          if (e.response.status === 409) {

            if (e.response.data && e.response.data[0]) {
              that.sendingRequest = false
            
              that.$toast.add({
                severity: "warn",
                detail: `An Enquiry was found that may be a duplicate of that opportunity, please verify that you wish to save that opportunity as new one`,
                life: 5000,
              });
          
              if (from === 'OpportunityForm.vue') {
                that.$emit("save", {
                  opportunity: realOpportunity, 
                  customer: that.selectedCustomer, 
                  duplicates: e.response.data,
                  sQuoteNo: realOpportunity.sQuoteNo
                });
                that.$emit("close");
              }
          
              realOpportunity = {};

            } else {
              
              that.opportunityService
                .saveDuplicateOpportunity(realOpportunity)
                .then((response) => {
                  that.sendingRequest = false
                
                  realOpportunity = response.data;
            
                  that.$toast.add({
                    severity: "success",
                    summary: "New Opportunity Saved",
                    detail: `new Opportunity was saved successfully, Quote No generated : ${realOpportunity.sQuoteNo}`,
                    life: 7000,
                  });
            
                  if (from === 'OpportunityForm.vue') {
                    that.$emit("save", {
                      opportunity: realOpportunity, 
                      customer: that.selectedCustomer, 
                      duplicateInfo: that.duplicateInfo,
                      sQuoteNo: realOpportunity.sQuoteNo,
                      emailStatus: realOpportunity.emailStatus
                    });
                    that.$emit("close");
                  }
                })
                .catch((e) => {
                  that.sendingRequest = false
                  
                  if (from === 'OpportunityForm.vue') {
                    that.$emit("save-failed")
                  }

                  if (e.response && e.response.status !== 200)                
                  that.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error while saving enquiry",
                    life: 5000,
                  })
                })

            }
          } else {
            that.sendingRequest = false

            if (from === 'OpportunityForm.vue') {
              that.$emit("save-failed")
            }
          
            if (e.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving enquiry",
              life: 5000,
            })
          }
        });
  
  
    }
  } else {
    that.sendingRequest = false

    
    
    // 
    // 
    // 
    try {
      if (!opportunity.oppDescription) {
        document.getElementById('oppDescription').focus()
      } else if (!opportunity.address1) {
        document.getElementById('address1').focus()
      } else if (!opportunity.address2) {
        document.getElementById('address2').focus()
      } else if (!opportunity.address3) {
        document.getElementById('address3').focus()
      } else if (!opportunity.cityTown) {
        document.getElementById('cityTown').focus()
      } else if (!opportunity.postCode) {
        document.getElementById('postCode').focus()
      } else if (!opportunity.customer) {
        document.getElementById('customer').focus()
      } else if (!opportunity.contact) {
        document.getElementById('contact').focus()
      } else if (!opportunity.mbpBranch) {
        document.getElementById('mbpBranch').focus()
      } else if (!opportunity.phoneNo) {
        document.getElementById('phoneNo').focus()
      } else if (!opportunity.email) {
        document.getElementById('email').focus()
      } else if (!opportunity.salesExec) {
        document.getElementById('salesExec').focus()
      } else if (!opportunity.projectType) {
        // document.getElementById('projectType').focus()
        that.$refs.projectType.$el.focus()
      } else if (!opportunity.dateReceived) {
        document.getElementById('dateReceived').focus()
      }
    } catch(e) {
      
    }
  }
}

function postFile (file, params, that) {
  if (file && params) {
    

    that.attachmentService
      .postFile(file, params)
      .then(res => {
        
        if (res && res.status === 200) {
          that.$toast.add({
            severity: "success",
            summary: res.data,
            detail: "File uploaded",
            life: 5000,
          });
        }
      })
      .catch(err => {
        

        if (err && err.response && err.response.data) {
          if (err.response.data.includes("exceeds the configured maximum")) {
            that.$toast.add({
              severity: "error",
              summary: "File too big.",
              detail: "File size exceeds the limited size.",
              life: 5000,
            });
          }
        }

      })
  }
}

export async function quotationRequest (that, from) {

  if (that.thisOpportunity && that.thisOpportunity.oppId)
    that.quotation.opportunity = that.thisOpportunity

  if (that.quoteVerDate)
    that.quotation.quoteVerDate = that.quoteVerDate

  if (that.productValue) {
    if (that.productValue.length) {
      if (that.productValue.length.length - 1 && that.productValue.length - 1 === '.') {
        that.quotation.productValue = `${that.productValue}0`
      } else if (that.productValue.length.length === 0 && that.productValue[0] === '.') {
        that.quotation.productValue = `0.0`
      } else {
        that.quotation.productValue = that.productValue
      }
    } else {
      that.quotation.productValue = '0.0'
    }
  }

  if (that.productType && that.productType.id)
    that.quotation.productType = that.productType

  if (that.quoteGrade && that.quoteGrade.id)
    that.quotation.quoteGrade = that.quoteGrade

  if (that.mbpBranch && that.mbpBranch.id)
    that.quotation.mbpBranch = that.mbpBranch
  
  if (!that.mbpBranch) {
    that.quotation.mbpBranch = null
  }

  var newQuotation = {...that.quotation}
  
  if (
    newQuotation.opportunity &&
    (
      (
        that.selectedCustomer &&
        that.selectedCustomer.customerId
      ) ||
      (
        newQuotation.customer &&
        newQuotation.customer.customerId
      )
    ) &&
    newQuotation.quoteVerDate &&
    newQuotation.productValue &&
    newQuotation.productType &&
    newQuotation.productType.id &&
    newQuotation.productQty &&
    newQuotation.versionNo &&
    newQuotation.expiryDate &&
    newQuotation.quoteGrade &&
    newQuotation.quoteStatus 
  ) {
    

    var active = false

    if (newQuotation.quoteStatus.statusName === 'Active') {
      active = true
    }

    let date
    date = moment(newQuotation.quoteVerDate).format("DD/MM/YYYY")
    
    if (date != "Invalid date") {
      newQuotation.quoteVerDateMoment = date
      if (that.quoteToEdit) {
        newQuotation.quoteVerDate = date
      }
    } else {
      newQuotation.quoteVerDateMoment = newQuotation.quoteVerDate
    }
    if (newQuotation.expectedOrderDate) {
      date = moment(newQuotation.expectedOrderDate).format("DD/MM/YYYY")
      
      if (date != "Invalid date") {
        newQuotation.expOrderDateMoment = date
        if (that.quoteToEdit) {
          newQuotation.expectedOrderDate = date
        }
      } else {
        newQuotation.expOrderDateMoment = newQuotation.expectedOrderDate
      }
    }
    if (newQuotation.reqDeliveryDate) {
      date = moment(newQuotation.reqDeliveryDate).format("DD/MM/YYYY")
      
      if (date != "Invalid date") {
        newQuotation.reqDeliveryDateMoment = date
        if (that.quoteToEdit) {
          newQuotation.reqDeliveryDate = date
        }
      } else {
        newQuotation.reqDeliveryDateMoment = newQuotation.reqDeliveryDate
      }
    }
    date = moment(newQuotation.expiryDate, "DD/MM/YYYY").format("DD/MM/YYYY")
    
    if (date != "Invalid date") {
      newQuotation.expiryDate = date
    }
    
    if (newQuotation.createdByDept && newQuotation.createdByDept.id) {
      newQuotation.createdByDept = newQuotation.createdByDept.id
    }
    if (that.selectedCustomer && that.selectedCustomer.customerId) {
      newQuotation.customer = that.selectedCustomer.customerId
    }
    if (newQuotation.customer && newQuotation.customer.customerId) {
      newQuotation.customer = newQuotation.customer.customerId
    }
    if (newQuotation.mbpBranch && newQuotation.mbpBranch.mbpBranchId) {
      newQuotation.mbpBranch = newQuotation.mbpBranch.mbpBranchId
    }
    if (newQuotation.mbpBranch && newQuotation.mbpBranch.id) {
      newQuotation.mbpBranch = newQuotation.mbpBranch.id
    }
    if (that.productType) {
      if (that.productType.id) {
        newQuotation.productType = that.productType.id
      }
    } else {
      newQuotation.productType = null
    }
    if (that.quoteGrade) {
      if (that.quoteGrade.id) {
        newQuotation.quoteGrade = that.quoteGrade.id
      }
    } else {
      newQuotation.quoteGrade = null
    }
    if (newQuotation.quoteStatus && newQuotation.quoteStatus.id) {
      newQuotation.quoteStatus = newQuotation.quoteStatus.id
    }
    if (newQuotation.opportunity && newQuotation.opportunity.oppId) {
      newQuotation.opportunity = newQuotation.opportunity.oppId
    }
    if (newQuotation.lostQuoteReason && newQuotation.lostQuoteReason.id) {
      newQuotation.lostQuoteReason = newQuotation.lostQuoteReason.id
    }
    delete newQuotation.createdBy
    delete newQuotation.updatedBy

    
    if (newQuotation.productValue && typeof newQuotation.productValue === 'string') {
      let data = newQuotation.productValue, a = []

      if (data.substring(0, 1) === '£') {
        a = data.substring(1, newQuotation.productValue)
      } else {
        a = newQuotation.productValue
      }

      let b = a.split('.')
      
      if (b.length > 2) {
        newQuotation.productValue = 0
      } else {
        let c = b[0].split(','), d = ''
        c.forEach(e => d = d.concat(e))
        if (b[1]) {
          
          newQuotation.productValue = parseFloat(`${d}.${b[1]}`).toFixed(2)
        } else {
          newQuotation.productValue = parseFloat(d).toFixed(2)
        }
      }
    }

    if (newQuotation.internalValue && typeof newQuotation.internalValue === 'string') {
      let data = newQuotation.internalValue, a = []

      if (data.substring(0, 1) === '£') {
        a = data.substring(1, newQuotation.internalValue)
      } else {
        a = newQuotation.internalValue
      }

      let b = a.split('.')
      
      if (b.length > 2) {
        newQuotation.internalValue = 0
      } else {
        let c = b[0].split(','), d = ''
        c.forEach(e => d = d.concat(e))
        if (b[1]) {
          newQuotation.internalValue = parseFloat(`${d}.${b[1]}`)
        } else {
          newQuotation.internalValue = parseInt(d)
        }
      }
    }

    var fileParams = {}

    if (that.file) {

      that.file.quotation = newQuotation.quoteVerId

      if (that.attachTags) {
        if (Array.isArray(that.attachTags)) {
          let a = that.attachTags.map(tag => {
            return {
              'tagId': tag.id
            }
          })
          that.attachTags = a
        }
  
        fileParams = {
          fileName: that.file.name,
          attachDesc: that.file.attachDesc,
          attachTags: that.attachTags,
          quotation: newQuotation.quoteVerId
        }

        if (that.selectedCustomer && that.selectedCustomer.customerId) {
          that.file.customer = that.selectedCustomer.customerId
          fileParams.customer = that.selectedCustomer.customerId
        }
      } else {
  
        fileParams = {
          fileName: that.file.name,
          attachDesc: that.file.attachDesc,
          quotation: newQuotation.quoteVerId
        }
        if (that.selectedCustomer && that.selectedCustomer.customerId) {
          that.file.customer = that.selectedCustomer.customerId
          fileParams.customer = that.selectedCustomer.customerId
        }
      }
    }

    
    
    if (newQuotation) {

      let quote1 = {...newQuotation}
      
      if (quote1.quoteType) {
        delete quote1.quoteType
      }
 

      if(quote1.chaseBy && quote1.chaseBy.id) {quote1.chaseBy = quote1.chaseBy.id} else {quote1.chaseBy = null}

      // Batch 5: an unusual value asks "Please check this value" first. "Go back" leaves the form open;
      // "Save anyway" sends anomalyConfirmed: true. If the check itself fails the save goes ahead as before.
      if (!(await checkBeforeQuoteSave(that, quote1))) {
        that.sendingRequest = false
        return
      }

      if (quote1.quoteVerId) {
        
        that.quotationService
          .updateQuotation(quote1.quoteVerId, quote1)
          .then((response) => {
            that.sendingRequest = false
            that.$toast.add({
              severity: "success",
              summary: response.data,
              detail: "Quotation Updated",
              life: 5000,
            });

            if (active) {
              that.quotationService
                .setQuoteAsActive(newQuotation.quoteVerId)
                .then(data => {
                  
                })
                .catch(err => {
                  
                })
            }
            
            if (from === 'QuotationForm.vue') {
              that.quotationDialog = false;
              newQuotation = {};
              that.selectedCustomer = {};
              that.productType = {};
              that.quoteGrade = {};
              that.$emit('saved', { quote: newQuotation, file: that.file, params: fileParams, active })
            
            } else if (from === 'CustomerDetail-customerQuotations.vue') {
              that.$refs.statuses.hide()
              that.selectedCustomer = {};
              that.productType = {};
              that.expiryDateDialog = false
              that.getCustomerQuotations()
              newQuotation = {}
            
            } else if (from === 'Quotation-Table.vue') {
              that.$refs.statuses.hide()
              that.selectedCustomer = {};
              that.productType = {};
              that.expiryDateDialog = false
              that.$emit('reload')
              newQuotation = {}
            
            } else if (from === 'versionsTable.vue') {
              that.$refs.statuses.hide()
              that.selectedCustomer = {};
              that.productType = {};
              that.$emit('reload')
              newQuotation = {}
            
            } else if (from === 'QuotationTableForLazyLoading.vue') {
              that.sendingRequest = false
              newQuotation = {}
              that.$emit('reload')

            } else if (from === 'QuotationTableForLazyLoadingWithResize.vue') {
              that.sendingRequest = false
              that.expiryDateDialog = false
              newQuotation = {}
              that.$emit('reload')

            }

            if (fileParams && fileParams.fileName) {
              fileParams.quotation = quote1.quoteVerId
              postFile(that.file, fileParams, that)
            }
          })
          .catch((e) => {
            that.sendingRequest = false
            

            if (e.response && e.response.status !== 200)                
              that.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating quotation",
                life: 5000,
              })
          });
      } else {
       
        that.quotationService
          .saveQuotation(quote1)
          .then((response) => {
            that.sendingRequest = false

            // D11: a new version may need the "restart follow-ups?" question. Never throws.
            announceQuoteVersionBooked(quote1.opportunity, response)

            
            that.$toast.add({
              severity: "success",
              summary: response.data,
              detail: "New Quotation Saved",
              life: 5000,
            });
            
            if (from === 'QuotationForm.vue') {
              that.$emit('saved', { quote: newQuotation, file: that.file, params: fileParams, active })
              newQuotation = {};
            
            } else if (from === 'CustomerDetail-customerQuotations.vue') {
              that.$refs.statuses.hide()
              that.expiryDateDialog = false
              that.getCustomerQuotations()
              newQuotation = {}
            
            } else if (from === 'Quotation-Table.vue') {
              that.$refs.statuses.hide()
              that.expiryDateDialog = false
              that.$emit('reload')
              newQuotation = {}

            } else if (from === 'versionsTable.vue') {
              that.$refs.statuses.hide()
              that.selectedCustomer = {};
              that.productType = {};
              that.$emit('reload')
              newQuotation = {}

            } else if (from === 'QuotationTableForLazyLoading.vue') {
              that.sendingRequest = false
              newQuotation = {}
              that.$emit('reload')

            } else if (from === 'QuotationTableForLazyLoadingWithResize.vue') {
              that.sendingRequest = false
              that.expiryDateDialog = false
              newQuotation = {}
              that.$emit('reload')

            }

            if (fileParams && fileParams.fileName) {
              fileParams.quotation = response
              postFile(that.file, fileParams, that)
            }
          })
          .catch((e) => {
            that.sendingRequest = false
            

            if (e.response && e.response.status !== 200)                
              that.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while saving quotation",
                life: 5000,
              })
          });
      }
    }
  } else {
    that.sendingRequest = false
    
    try {
      if (!that.quotation.quoteVerDate) {
        document.getElementById('quoteVerDate').focus()
      } else if (!that.quotation.productValue) {
        document.getElementById('productValue').focus()
      } else if (!that.quotation.opportunity) {
        document.getElementById('opportunity').focus()
      } else if (!that.selectedCustomer.customerId) {
        document.getElementById('customer').focus()
      } else if (!that.quotation.productQty) {
        document.getElementById('productQty').focus()
      } else if (!that.quotation.productType) {
        document.getElementById('productType').focus()
      } else if (!that.quotation.versionNo) {
        document.getElementById('versionNo').focus()
      } else if (!that.quotation.expiryDate) {
        document.getElementById('expiryDate').focus()
      } else if (!that.quotation.mbpBranch) {
        document.getElementById('mbpBranch').focus()
      }
    } catch(e) {
      
    }
  }
}

export function customerRequest (that, from) {

  if (that.postCode)
    that.customer.postCode = that.postCode

  if (that.customerType && that.customerType.id)
    that.customer.customerType = that.customerType

  if (that.mbpBranch && that.mbpBranch.id)
    that.customer.mbpBranch = that.mbpBranch

  if (that.region && that.region.id)
    that.customer.region = that.region

  if (that.salesExec && that.salesExec.id)
    that.customer.salesExec = that.salesExec

  if (that.cityTown && that.cityTown.id)
    that.customer.cityTown = that.cityTown

  if (!that.customer.country)
    that.customer.country = 'UK'


  var newCustomer = {...that.customer}  


  // if ((that.customer.parentFlag && that.customer.parentCustomer) || !(that.customer.parentFlag && !that.customer.parentCustomer)) {
    if (
      newCustomer.custName && 
      newCustomer.address1 &&
      newCustomer.address2 &&
      newCustomer.address3 &&
      newCustomer.cityTown &&
      // newCustomer.country && 
      newCustomer.customerType &&
      newCustomer.phoneNo &&
      newCustomer.region &&
      newCustomer.mbpBranch &&
      newCustomer.salesExec
    ) {
      
      try {
        if (that.customerToEdit && that.customerToEdit.customerId && that.contacts && that.contacts.length && !(newCustomer.keyContact)) {
          that.sendingRequest = false
          document.getElementById('keyContact').focus()
          return
        } 
      } catch(e) {}
      
      if (Array.isArray(newCustomer.tags)) {
        const { payload, invalid } = toTagIdPayload(newCustomer.tags)

        // The form drops names it could not match, so the selection can look perfectly
        // valid while silently omitting a tag the customer still holds. Sending it would
        // delete that tag, because the backend replaces the whole set. Treat it the same
        // as an invalid entry: leave the stored tags alone.
        const hasUnresolved = Array.isArray(that.unresolvedTagNames) && that.unresolvedTagNames.length > 0

        if (invalid || hasUnresolved) {
          // At least one entry is not a real tag (e.g. its name was renamed since this
          // customer was last saved). Previously this threw, was swallowed, and sent an
          // empty list - which made the backend delete every tag the customer had.
          // Omitting the key entirely leaves the stored tags untouched: the backend only
          // acts on tags when the key is present (CustomerControllerHandler.kt:1026,
          // CustomerRepository.kt:461).
          delete newCustomer.tags

          if (that.$toast) {
            const stale = hasUnresolved ? ' (' + that.unresolvedTagNames.join(', ') + ')' : ''
            that.$toast.add({
              severity: "warn",
              summary: "Tags not updated",
              detail: "This customer holds a tag that no longer exists" + stale + ", so its tags were left unchanged. Everything else was saved.",
              life: 8000,
            })
          }
        } else {
          newCustomer.tags = payload
        }
      }

      
      if (newCustomer.mbpBranch) {
        if (newCustomer.mbpBranch.id) {
          newCustomer.mbpBranch = newCustomer.mbpBranch.id
        }
      } else {
        newCustomer.mbpBranch = null
      }
      if (newCustomer.branch) {
        if (newCustomer.branch.id) {
          newCustomer.branch = newCustomer.branch.id
        }
      } else {
        newCustomer.branch = null
      }
      if (newCustomer.industryType) {
        if (newCustomer.industryType.id) {
          newCustomer.industryType = newCustomer.industryType.id;
        }
      } else {
        newCustomer.industryType = null
      }
      if (newCustomer.region) {
        if (newCustomer.region.id) {
          newCustomer.region = newCustomer.region.id;
        }
      } else {
        newCustomer.region = null
      }
      if (newCustomer.salesExec) {
        if (newCustomer.salesExec.id) {
          newCustomer.salesExec = newCustomer.salesExec.id;
        }
      } else {
        newCustomer.salesExec = null
      }
      if (newCustomer.cityTown) {
        if (newCustomer.cityTown.id) {
          newCustomer.cityTown = newCustomer.cityTown.id;
        }
      } else {
        newCustomer.cityTown = null
      }
      if (newCustomer.keyContact) {
        if (newCustomer.keyContact.contactId) {
          newCustomer.keyContact = newCustomer.keyContact.contactId;
        }
      } else {
        newCustomer.keyContact = null
      }
      if (newCustomer.parentCustomer) {
        if (newCustomer.parentCustomer.customerId) {
          newCustomer.parentCustomer = newCustomer.parentCustomer.customerId
        }
      } else {
        newCustomer.parentCustomer = null
      }
      if (newCustomer.customer) {
        if (newCustomer.customer.customerId) {
          newCustomer.customer = newCustomer.customer.customerId
        }
      } else {
        newCustomer.customer = null
      }
      if (newCustomer.customerType) {
        if (newCustomer.customerType.id) {
          newCustomer.customerType = newCustomer.customerType.id
        }
      } else {
        newCustomer.customerType = null
      }

      delete newCustomer.createdBy
      delete newCustomer.updatedBy

      if (newCustomer.custCode)
        newCustomer.custCode = newCustomer.custCode.toUpperCase()
      if (newCustomer.custName)
        newCustomer.custName = newCustomer.custName.toUpperCase()
      if (newCustomer.address1)
        newCustomer.address1 = newCustomer.address1.toUpperCase()
      if (newCustomer.address2)
        newCustomer.address2 = newCustomer.address2.toUpperCase()
      if (newCustomer.address3)
        newCustomer.address3 = newCustomer.address3.toUpperCase()
      if (newCustomer.address4)
        newCustomer.address4 = newCustomer.address4.toUpperCase()
      if (newCustomer.postCode)
        newCustomer.postCode = newCustomer.postCode.toUpperCase()

      
      if (newCustomer.customerId) {
        
        that.customerService
          .updateCustomer(newCustomer.customerId, newCustomer)
          .then((response) => {
  
            that.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Customer Updated",
              life: 5000,
            });

            if (that.customerForApproval && that.customerForApproval.customerId) {
              that.customerService
                .assignCustomer(newCustomer.customerId, that.customerForApproval.customerId)
                .then(data => {
                  that.sendingRequest = false
      
                  if (from === 'customerForm.vue') {
                    that.$emit('saved', { customer: newCustomer })
                    newCustomer = {};
                  }
                })
                .catch(error => {
                  that.sendingRequest = false
      
                  if (from === 'customerForm.vue') {
                    that.$emit('saved', { customer: newCustomer })
                    newCustomer = {};
                  }
      
                  that.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error while assigning customer.",
                    life: 5000,
                  })
                })
            } else {
              that.sendingRequest = false
  
              if (from === 'customerForm.vue') {
                that.$emit('saved', { customer: newCustomer })
                newCustomer = {};
              }
            }
          })
          .catch((e) => {
            that.sendingRequest = false
            

            if (e.response && e.response.status !== 200)                
              that.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating customer",
                life: 5000,
              })
          });
      } else {
        
        that.customerService
          .saveCustomer(newCustomer)
          .then((response) => {
            that.sendingRequest = false
            that.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "New Customer Saved",
              life: 5000,
            });

            if (from === 'customerForm.vue') {
              that.$emit('saved', { customer: newCustomer })
              newCustomer = {};
            }
          })
          .catch((e) => {
            that.sendingRequest = false
            
            if (e.response.status === 409) {
              
              that.$toast.add({
                severity: "warn",
                detail: `An Customer was found that may be a duplicate of that customer`, 
                life: 5000,
              });

              if (from === 'customerForm.vue') {
                that.$emit('saved', { 
                  customer: newCustomer, 
                  duplicates: e.response.data
                })
                newCustomer = {};
              }
            } else {

              if (e.response && e.response.status !== 200)                
                that.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error while saving customer",
                  life: 5000,
                })
            }
          });
      }

      
    } else {
      that.sendingRequest = false

      
      try {
        if (!that.customer.custName) {
          document.getElementById('custName').focus()
        } else if (!that.customer.address1) {
          document.getElementById('address1').focus()
        } else if (!that.customer.address2) {
          document.getElementById('address2').focus()
        } else if (!that.customer.address3) {
          document.getElementById('address3').focus()
        } else if (!that.customer.cityTown) {
          document.getElementById('cityTown').focus()
        // } else if (!that.customer.country) {
        //   document.getElementById('country').focus()
        } else if (!that.customer.customerType) {
          document.getElementById('customerType').focus()
        } else if (!that.customer.region) {
          document.getElementById('region').focus()
        } else if (!that.customer.mbpBranch) {
          document.getElementById('mbpBranch').focus()
        } else if (!that.customer.salesExec) {
          document.getElementById('salesExec').focus()
        } else if (!that.customer.phoneNo) {
          document.getElementById('phoneNo').focus()
        }
      } catch(e) {
        
      }
    }
  // }
}

export function customerLessDataRequest (that, from) {

  if (that.customerType && that.customerType.id)
    that.customer.customerType = that.customerType
    if (that.cityTown && that.cityTown.id)
      that.customer.cityTown = that.cityTown

  if (!that.customer.country)
    that.customer.country = 'UK'

  that.customer.requireApproval = true

  var newCustomer = {...that.customer}

  // if ((newCustomer.parentFlag && newCustomer.parentCustomer) || !(newCustomer.parentFlag && !newCustomer.parentCustomer)) {
    if (
      newCustomer.custName && 
      newCustomer.address1 &&
      newCustomer.address2 &&
      newCustomer.address3 &&
      newCustomer.cityTown &&
      newCustomer.customerType &&
      newCustomer.phoneNo
    ) {
      
      
        if (newCustomer.mbpBranch) {
          if (newCustomer.mbpBranch.id) {
               newCustomer.mbpBranch = newCustomer.mbpBranch.id
          }
        } else {
          newCustomer.mbpBranch = null
        }
        if (newCustomer.branch) {
          if (newCustomer.branch.id) {
            newCustomer.branch = newCustomer.branch.id
          }
        } else {
          newCustomer.branch = null
        }
        if (newCustomer.industryType) {
          if (newCustomer.industryType.id) {
            newCustomer.industryType = newCustomer.industryType.id;
          }
        } else {
          newCustomer.industryType = null
        }
        if (newCustomer.region) {
          if (newCustomer.region.id) {
            newCustomer.region = newCustomer.region.id;
          }
        } else {
          newCustomer.region = null
        }
        if (newCustomer.salesExec) {
          if (newCustomer.salesExec.id) {
            newCustomer.salesExec = newCustomer.salesExec.id;
          }
        } else {
          newCustomer.salesExec = null
        }
        if (newCustomer.cityTown) {
          if (newCustomer.cityTown.id) {
            newCustomer.cityTown = newCustomer.cityTown.id;
          }
        } else {
          newCustomer.cityTown = null
        }
        if (newCustomer.keyContact) {
          if (newCustomer.keyContact.contactId) {
            newCustomer.keyContact = newCustomer.keyContact.contactId;
          }
        } else {
          newCustomer.keyContact = null
        }
        if (newCustomer.parentCustomer) {
          if (newCustomer.parentCustomer.customerId) {
            newCustomer.parentCustomer = newCustomer.parentCustomer.customerId
          }
        } else {
          newCustomer.parentCustomer = null
        }
        if (newCustomer.customer) {
          if (newCustomer.customer.customerId) {
            newCustomer.customer = newCustomer.customer.customerId
          }
        } else {
          newCustomer.customer = null
        }
        if (newCustomer.customerType) {
          if (newCustomer.customerType.id) {
            newCustomer.customerType = newCustomer.customerType.id
          }
        } else {
          newCustomer.customerType = null
        }

      delete newCustomer.createdBy
      delete newCustomer.updatedBy

      if (newCustomer.custCode)
        newCustomer.custCode = newCustomer.custCode.toUpperCase()
      if (newCustomer.custName)
        newCustomer.custName = newCustomer.custName.toUpperCase()
      if (newCustomer.address1)
        newCustomer.address1 = newCustomer.address1.toUpperCase()
      if (newCustomer.address2)
        newCustomer.address2 = newCustomer.address2.toUpperCase()
      if (newCustomer.address3)
        newCustomer.address3 = newCustomer.address3.toUpperCase()
      if (newCustomer.address4)
        newCustomer.address4 = newCustomer.address4.toUpperCase()
      if (newCustomer.postCode)
        newCustomer.postCode = newCustomer.postCode.toUpperCase()

      

      if (!newCustomer.customerId) {
        
        that.customerService
          .saveCustomer(newCustomer)
          .then((response) => {
            that.sendingRequest = false
            that.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "New Customer Saved",
              life: 5000,
            });

            if (from === 'customerForm.vue') {
              that.$emit('saved', { customer: newCustomer })
              newCustomer = {};
            } else if (from === 'OpportunityForm.vue' || from === 'ActivityForm.vue' || from === 'NoteForm.vue') {
              that.contactFormDialog = false
              that.customerFormDialog = false
              that.custSearchDialog = true
              that.loadCustomersAgain++
              that.preSelectedCustomer = response.data
              newCustomer = {};
            } else if (from === 'ContactForm.vue') {
              that.customerFormDialog = false
              that.custSearchDialog = true
              that.loadCustomersAgain++
              newCustomer = {};
            }
          })
          .catch((e) => {
            that.sendingRequest = false
            
            if (e.response.status === 409) {
              
              that.$toast.add({
                severity: "warn",
                detail: `An Customer was found that may be a duplicate of that customer`, 
                life: 5000,
              });

              if (from === 'customerForm.vue') {
                that.$emit('saved', { 
                  customer: newCustomer, 
                  duplicates: e.response.data
                })
                newCustomer = {};
              } else if (from === 'OpportunityForm.vue' || from === 'ActivityForm.vue' || from === 'ContactForm.vue' || from === 'NoteForm.vue') {
                that.customerDuplicateMessage = true
              }
            } else {
              if (e.response.status !== 200)                
                that.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error while saving customer",
                  life: 5000,
                })
            }
          });
      } else {
        
        that.customerService
          .updateCustomer(newCustomer.customerId, newCustomer)
          .then((response) => {
  
            that.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Customer Updated",
              life: 5000,
            });

            
            if (that.customerForApproval && that.customerForApproval.customerId) {
              that.customerService
                .assignCustomer(newCustomer.customerId, that.customerForApproval.customerId)
                .then(data => {
                  that.sendingRequest = false
      
                  if (from === 'customerForm.vue') {
                    that.$emit('saved', { customer: newCustomer })
                    newCustomer = {};
                  }
                })
                .catch(error => {
                  that.sendingRequest = false
      
                  if (from === 'customerForm.vue') {
                    that.$emit('saved', { customer: newCustomer })
                    newCustomer = {};
                  }
      
                  that.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error while assigning customer.",
                    life: 5000,
                  })
                })
            } else {
              that.sendingRequest = false
  
              if (from === 'customerForm.vue') {
                that.$emit('saved', { customer: newCustomer })
                newCustomer = {};
              }
            }
          })
          .catch((e) => {
            that.sendingRequest = false
            

            if (e.response && e.response.status !== 200)                
              that.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating customer",
                life: 5000,
              })
          });
      }
    } else {
      that.sendingRequest = false

      
      try {
        if (!that.customer.custName) {
          document.getElementById('custName').focus()
        } else if (!that.customer.address1) {
          document.getElementById('address1').focus()
        } else if (!that.customer.address2) {
          document.getElementById('address2').focus()
        } else if (!that.customer.address3) {
          document.getElementById('address3').focus()
        } else if (!that.customer.cityTown) {
          document.getElementById('cityTown').focus()
        } else if (!that.customer.customerType) {
          document.getElementById('customerType').focus()
        } else if (!that.customer.phoneNo) {
          document.getElementById('phoneNo').focus()
        }
      } catch(e) {
        
      }
    }
  // }
}

export function customerConf (that, from) {

  var newCustomer = {...that.customer}
      
  if (newCustomer.mbpBranch) {
    if (newCustomer.mbpBranch.id) {
      newCustomer.mbpBranch = newCustomer.mbpBranch.id
    }
  } else {
    newCustomer.mbpBranch = null
  }
  if (newCustomer.branch) {
    if (newCustomer.branch.id) {
      newCustomer.branch = newCustomer.branch.id
    }
  } else {
    newCustomer.branch = null
  }
  if (newCustomer.industryType) {
    if (newCustomer.industryType.id) {
      newCustomer.industryType = newCustomer.industryType.id;
    }
  } else {
    newCustomer.industryType = null
  }
  if (newCustomer.region) {
    if (newCustomer.region.id) {
      newCustomer.region = newCustomer.region.id;
    }
  } else {
    newCustomer.region = null
  }
  if (newCustomer.salesExec) {
    if (newCustomer.salesExec.id) {
      newCustomer.salesExec = newCustomer.salesExec.id;
    }
  } else {
    newCustomer.salesExec = null
  }
  if (newCustomer.cityTown) {
    if (newCustomer.cityTown.id) {
      newCustomer.cityTown = newCustomer.cityTown.id;
    }
  } else {
    newCustomer.cityTown = null
  }
  if (newCustomer.keyContact) {
    if (newCustomer.keyContact.contactId) {
      newCustomer.keyContact = newCustomer.keyContact.contactId;
    }
  } else {
    newCustomer.keyContact = null
  }
  if (newCustomer.parentCustomer) {
    if (newCustomer.parentCustomer.customerId) {
      newCustomer.parentCustomer = newCustomer.parentCustomer.customerId
    }
  } else {
    newCustomer.parentCustomer = null
  }
  if (newCustomer.customer) {
    if (newCustomer.customer.customerId) {
      newCustomer.customer = newCustomer.customer.customerId
    }
  } else {
    newCustomer.customer = null
  }
  if (newCustomer.customerType) {
    if (newCustomer.customerType.id) {
      newCustomer.customerType = newCustomer.customerType.id
    }
  } else {
    newCustomer.customerType = null
  }


  delete newCustomer.createdBy
  delete newCustomer.updatedBy

  if (
    from === 'ActivityForm.vue' 
    || from === 'contactForm.vue'
    || from === 'NoteForm.vue'
    || from === 'OpportunityForm.vue'
  ) {
    that.customerDuplicateMessage = false
  } else {
    that.duplicateRequesting = true
  }

  

  that.customerService
    .saveDuplicateCustomer(newCustomer)
    .then((response) => {


      if (from !== 'ActivityForm.vue') {
        that.duplicateRequesting = false
        that.displayDuplicateMessage = false
      }
      
      
      if (response.status === 200) {
        that.$toast.add({
          severity: "success",
          summary: "Customer Saved",
          detail: `New Customer was saved successfully`,
          life: 5000,
        });
        
        if (
          from === 'customerApproval.vue'
          || from === 'Customers.vue'
        ) {
          that.customers.push(response.data)
          that.reload()

        } else if (from === 'ActivityForm.vue') {
          that.contactFormDialog = false
          that.customerFormDialog = false
          that.custSearchDialog = true
          that.preSelectedCustomer = response.data
          that.loadCustomersAgain++

        } else if (from === 'contactForm.vue') {
          that.customerFormDialog = false
          that.custSearchDialog = true
          that.preSelectedCustomer = response.data
          that.loadCustomersAgain++

        } else if (from === 'NoteForm.vue') {
          that.preSelectedCustomer = response.data
          that.customerFormDialog = false
          that.custSearchDialog = true
          that.loadCustomersAgain++

        } else if (from === 'OpportunityForm.vue') {
          that.preSelectedCustomer = response.data
          that.contactFormDialog = false
          that.customerFormDialog = false
          that.custSearchDialog = true
          that.loadCustomersAgain++

        }
      }
    })
    .catch((e) => {

      if (from !== 'ActivityForm.vue') {
        that.duplicateRequesting = false
        that.displayDuplicateMessage = false
      }
      
            
      that.$toast.add({
        severity: "error",
        summary: "Error",
        detail: "Error while saving customer",
        life: 5000,
      })
    })
}

export function contactRequest (that, from) {
  if (!that.contact.country)
    that.contact.country = 'UK'


  var newContact = {...that.contact}
    
  if (
    newContact.firstName && 
    newContact.lastName &&
    newContact.customer &&
    newContact.jobFunction &&
    newContact.email &&
    newContact.address1 &&
    newContact.address2 &&
    newContact.address3 &&
    newContact.cityTown &&
    newContact.phoneNo &&
    newContact.cityTown.id
  ) {

    if (newContact.customer) {
      newContact.customer = newContact.customer.customerId;
    }
    if (newContact.contactType) {
      newContact.contactType = newContact.contactType.id;
    }
    if (newContact.jobFunction) {
      newContact.jobFunction = newContact.jobFunction.id;
    }
    if (newContact.cityTown) {
      newContact.cityTown = newContact.cityTown.id;
    }
    if (newContact.jobTitle) {
      newContact.jobTitle = newContact.jobTitle.id;
    }
    if (newContact.salutation) {
      newContact.salutation = newContact.salutation.id;
    }
    if (newContact.updatedBy) {
      newContact.updatedBy = newContact.updatedBy.id;
    }

    if (newContact.canEmail === null || newContact.canEmail === undefined) {
      newContact.canEmail = false
    }
    if (newContact.canCall === null || newContact.canCall === undefined) {
      newContact.canCall = false
    }
    if (newContact.canMail === null || newContact.canMail === undefined) {
      newContact.canMail = false
    }
    if (newContact.keyContact === null || newContact.keyContact === undefined) {
      newContact.keyContact = false
    }
    if (newContact.active === null || newContact.active === undefined) {
      newContact.active = false
    }
    delete newContact.createdBy

    if (newContact.firstName)
      newContact.firstName = newContact.firstName.toUpperCase()
    if (newContact.lastName)
      newContact.lastName = newContact.lastName.toUpperCase()
    if (newContact.address1)
      newContact.address1 = newContact.address1.toUpperCase()
    if (newContact.address2)
      newContact.address2 = newContact.address2.toUpperCase()
    if (newContact.address3)
      newContact.address3 = newContact.address3.toUpperCase()
    if (newContact.address4)
      newContact.address4 = newContact.address4.toUpperCase()
    if (newContact.postCode)
      newContact.postCode = newContact.postCode.toUpperCase()

    

    if (newContact.contactId) {

      that.customerService
        .updateContactDB(newContact.contactId, newContact)
        .then(response => {
          that.sendingRequest = false

          that.$toast.add({
            severity: "success",
            summary: response.data,
            detail: "Contact Updated",
            life: 5000,
          });

          if (from === 'contactForm.vue') {
            that.$emit('submit-contact-form', { contact: newContact })
          }

        })
        .catch((e) => {
          that.sendingRequest = false
          

          if (e.response && e.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating contact",
              life: 5000,
            })
        });
        
    } else {
      
      that.customerService
        .saveContactDB(newContact)
        .then(response => {
          that.sendingRequest = false

          that.$toast.add({
            severity: "success",
            summary: response.data,
            detail: "New Contact Saved",
            life: 5000,
          });

          if (from === 'contactForm.vue') {
            that.$emit('submit-contact-form', { contact: newContact })
          } else if (from === 'OpportunityForm.vue' || from === 'ActivityForm.vue' || from === 'NoteForm.vue') {
            that.contactFormDialog = false
            that.customerFormDialog = false
            that.custSearchDialog = true
          }

        })
        .catch(err => {
          

          if (err.response.status === 409) {
            that.sendingRequest = false

            that.$toast.add({
              severity: "warn",
              detail: `A contact was found that may be a duplicate of that contact, please verify that you wish to save that contact as new one`,
              life: 5000,
            });

            that.duplicateToSend = {...newContact}

            if (err.response.data && err.response.data[0]) {
              that.duplicateContact = err.response.data[0]
            }
            

            if (from === 'contactForm.vue') {
              that.$emit('submit-contact-form', { contact: newContact, duplicateContact: that.duplicateContact, duplicateToSend: that.duplicateToSend })
            } else if (from === 'OpportunityForm.vue' || from === 'ActivityForm.vue' || from === 'NoteForm.vue') {
              that.duplicateDialog = true
            }
            
          } else {
            that.sendingRequest = false

            if (err.response.status !== 200)                
              that.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while saving contact",
                life: 5000,
              })
          }
        });
    }
  } else {
    that.sendingRequest = false
    
    try {
      if (!that.contact.firstName) {
        document.getElementById('firstName').focus()
      } else if (!that.contact.lastName) {
        document.getElementById('lastName').focus()
      } else if (!that.contact.customer) {
        document.getElementById('customer').focus()
      } else if (!that.contact.jobFunction) {
        document.getElementById('jobFunction').focus()
      } else if (!that.contact.email) {
        document.getElementById('email').focus()
      } else if (!that.contact.address1) {
        document.getElementById('address1').focus()
      } else if (!that.contact.address2) {
        document.getElementById('address2').focus()
      } else if (!that.contact.address3) {
        document.getElementById('address3').focus()
      } else if (!(that.contact.cityTown && that.contact.cityTown.id)) {
        document.getElementById('cityTown').focus()
      }
    } catch(e) {
      
    }
  }
}

// Focus a form field if the form renders it: the task form has no duration or end.
function focusField(id) {
  const field = document.getElementById(id)
  if (field) field.focus()
}

export function activityRequest (that, from) {
  let errors = 0;


  var newActivity = {...that.activity}
  
  if (that.activityType) {
    newActivity.activityType = that.activityType
  }

  // ActivityForm in mode "task", or in mode "auto" with a TASK-kind type selected: every
  // type needs its When, none has a duration or end (a Meeting changed to a Call drops
  // its old end and duration).
  const taskMode = effectiveModeFor(that.mode, that.activityType) === 'task'
    
  if (
    newActivity && 
    newActivity.activityType && 
    (taskMode || newActivity.activityType.activityTypeName !== "Task") &&
    !that.startDate
  ) {
    errors++
    focusField('startDate')
  } else {
    newActivity.startDate = that.startDate
  }
  
  if (
    newActivity && 
    newActivity.activityType && 
    (taskMode || newActivity.activityType.activityTypeName !== "Task") &&
    !that.startTime
  ) {
    errors++
    focusField('startTime')
  } else {
    newActivity.startTime = that.startTime
  }
  
  // Making sure that start Date/time is in future
  if (that.showStartDateError) {
    errors++
    focusField('startDate')
    focusField('startTime')
  }

  if (
    !taskMode &&
    newActivity && 
    newActivity.activityType && 
    newActivity.activityType.activityTypeName !== "Task" &&
    !that.duration
  ) {
    errors++
    focusField('duration')
  } else {
    newActivity.duration = that.duration
  }
    
  if (
    taskMode ||
    (newActivity &&
    newActivity.activityType && 
    newActivity.activityType.activityTypeName === "Task")
  ) {
    // delete newActivity.startDate
    // delete newActivity.startTime
    delete newActivity.duration
    delete newActivity.endDate
    delete newActivity.endTime
  }

  
    
  if (
    !taskMode &&
    (that.activityType && that.activityType.activityTypeName === 'Meeting') &&
    !newActivity.endDate
  ) {
    errors++
    focusField('endDate')
  }
    
  if (
    !taskMode &&
    (that.activityType && that.activityType.activityTypeName === 'Meeting') &&
    !newActivity.endTime
  ) {
    errors++
    focusField('endTime')
  }
  
  if (
    (that.reminder && that.reminder.value) &&
    newActivity && 
    !
    (
      newActivity.reminderType &&
      newActivity.reminderType.id
    )
  ) {
    errors++
    focusField('reminderType')
  }
  
  if (
    (that.reminder && that.reminder.value) &&
    newActivity && 
    !newActivity.reminderDate
  ) {
    errors++
    focusField('reminderDate')
  }
  
  if (
    (that.reminder && that.reminder.value) &&
    newActivity && 
    !newActivity.reminderTime
  ) {
    errors++
    focusField('reminderTime')
  }
    
  if (
    !(that.reminder && that.reminder.value) &&
    newActivity
  ) {
    
    delete newActivity.reminderType
    delete newActivity.reminderDate
    delete newActivity.reminderTime
  }
  

  if (that.activityStatus) {
    newActivity.activityStatus = that.activityStatus
  }

  if (!newActivity.activityResult)
    delete newActivity.activityResult
    
  
  if (
    newActivity &&
    newActivity.subject &&
    newActivity.dateCreated &&
    !errors
  ) {

    // Save Date
    let a = moment(newActivity.dateCreated).format("DD/MM/YYYY");
    if (a != "Invalid date") {
      newActivity.dateCreatedMoment = a;
    } else {
      newActivity.dateCreatedMoment = newActivity.dateCreated;
    }

    if (newActivity.startDate) {
      a = moment(newActivity.startDate).format("DD/MM/YYYY");
      if (a != "Invalid date") {
        newActivity.startDateMoment = a;
      } else {
        newActivity.startDateMoment = newActivity.startDate;
      }
    } else {
      newActivity.startDateMoment = null
    }

    if (newActivity.NewStartDate) {
      a = moment(newActivity.NewStartDate).format("DD/MM/YYYY");
      if (a != "Invalid date") {
        newActivity.NewStartDate = a;
      } else {
        newActivity.NewStartDate = newActivity.NewStartDate;
      }
    } else {
      newActivity.NewStartDate = null
    }

    if (newActivity.endDate) {
      a = moment(newActivity.endDate).format("DD/MM/YYYY");
      if (a != "Invalid date") {
        newActivity.endDateMoment = a;
      } else {
        newActivity.endDateMoment = newActivity.endDate;
      }
    } else {
      newActivity.endDateMoment = null
    }

    a = moment(newActivity.deadlineDate).format("DD/MM/YYYY");
    if (a != "Invalid date") {
      newActivity.deadlineDateMoment = a;
    } else {
      newActivity.deadlineDateMoment = newActivity.deadlineDate;
    }

    a = moment(newActivity.reminderDate).format("DD/MM/YYYY");
    if (a != "Invalid date") {
      newActivity.reminderDateMoment = a;
    } else {
      newActivity.reminderDateMoment = newActivity.reminderDate;
    }

    if (newActivity.startTime) {
      a = moment(newActivity.startTime).format("HH:mm");
      if (a != "Invalid date") {
        newActivity.startTimeMoment = a;
      } else {
        newActivity.startTimeMoment = newActivity.startTime;
      }
    } else {
      newActivity.startTimeMoment = null
    }

    if (newActivity.NewStarTime) {
      a = moment(newActivity.NewStarTime).format("HH:mm");
      if (a != "Invalid date") {
        newActivity.NewStarTime = a;
      } else {
        newActivity.NewStarTime = newActivity.NewStarTime;
      }
    } else {
      newActivity.NewStarTime = null
    }

    if (newActivity.endTime) {
      a = moment(newActivity.endTime).format("HH:mm");
      if (a != "Invalid date") {
        newActivity.endTimeMoment = a;
      } else {
        newActivity.endTimeMoment = newActivity.endTime;
      }
    } else {
      newActivity.endTimeMoment = null
    }

    a = moment(newActivity.deadlineTime).format("HH:mm");
    if (a != "Invalid date") {
      newActivity.deadlineTimeMoment = a;
    } else {
      newActivity.deadlineTimeMoment = newActivity.deadlineTime;
    }

    a = moment(newActivity.reminderTime).format("HH:mm");
    if (a != "Invalid date") {
      newActivity.reminderTimeMoment = a;
    } else {
      newActivity.reminderTimeMoment = newActivity.reminderTime;
    }

    if (newActivity.mbpBranch && newActivity.mbpBranch.id)
      newActivity.mbpBranch = newActivity.mbpBranch.id;
    if (newActivity.customer && newActivity.customer.customerId)
      newActivity.customer = newActivity.customer.customerId;
    if (newActivity.contact && newActivity.contact.contactId)
      newActivity.contact = newActivity.contact.contactId;
    if (newActivity.activityType && newActivity.activityType.id)
      newActivity.activityType = newActivity.activityType.id;
    if (newActivity.activityResult && newActivity.activityResult.id)
      newActivity.activityResult = newActivity.activityResult.id;
    if (newActivity.activityStatus && newActivity.activityStatus.id)
      newActivity.activityStatus = newActivity.activityStatus.id;
    if (newActivity.reminderType && newActivity.reminderType.id)
      newActivity.reminderType = newActivity.reminderType.id;
    if (newActivity.user && newActivity.user.id)
      newActivity.user = newActivity.user.id;
    if (newActivity.quote && newActivity.quote.quoteVerId)
      newActivity.quote = newActivity.quote.quoteVerId;
    if (newActivity.supervisor && newActivity.supervisor.id)
      newActivity.supervisor = newActivity.supervisor.id

    delete newActivity.createdBy
    delete newActivity.updatedBy

    Object.keys(newActivity).forEach(key => {
      // 
      if (newActivity[key] instanceof Object && !( key === 'startTime' || key === 'startDate' || key === 'dateCreated' || key === 'reminderDate' || key === 'reminderTime' || key === 'endDate' || key === 'endTime' )) {
        delete newActivity[key]
      }
    })

    

    if (newActivity.activityId) {
      
      that.activityService
        .updateActivity(newActivity.activityId, newActivity)
        .then((response) => {
          that.sendingRequest = false
          
          
          that.$toast.add({
            severity: "success",
            summary: response.data,
            detail: (taskMode ? "Task" : "Event") + " Updated",
            life: 5000,
          });
          
          if (from === 'ActivityForm.vue') {
            that.$emit('saved', { activity: newActivity })
            
          } else if (from === '1ActivityForm.vue') {
            that.updateStatus(that.tempStatus)
          
          } else if (from === 'CustomerDetail-customerActivities.vue') {
            that.activityDialog = false;
            that.$refs.statuses.hide()
            that.getCustomerActivities(that.$route.params.custid)
          
          } else if (from === 'ActivitiesDataTable.vue') {
            that.$refs.statuses.hide()
            that.$emit('reload')
          }

        })
        .catch((e) => {
          that.sendingRequest = false
          

          if (e.response && e.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating the " + (taskMode ? "task" : "event"),
              life: 5000,
            })
        });
    } else {
      
      that.activityService
        .saveActivity(newActivity)
        .then((response) => {
          that.sendingRequest = false
          that.$toast.add({
            severity: "success",
            summary: response.data,
            detail: "New " + (taskMode ? "Task" : "Event") + " Saved",
            life: 5000,
          });
          
          if (from === 'ActivityForm.vue') {
            that.$emit('saved', { activity: newActivity })

          } else if (from === '1ActivityForm.vue') {
            that.updateStatus(that.tempStatus)
          
          } else if (from === 'CustomerDetail-customerActivities.vue') {
            that.activityDialog = false;
            that.$refs.statuses.hide()
            that.getCustomerActivities(that.$route.params.custid)
          
          } else if (from === 'ActivitiesDataTable.vue') {
            that.$refs.statuses.hide()
            that.$emit('reload')
          }

        })
        .catch((e) => {
          that.sendingRequest = false
          

          if (e.response && e.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving the " + (taskMode ? "task" : "event"),
              life: 5000,
            })
        });
    }
  } else {
    that.sendingRequest = false
    
    try {
      if (!that.activity.subject) {
        focusField('subject')
      } else if (!that.activity.dateCreated) {
        focusField('dateCreated')
      } else if (!that.activity.startDate) {
        focusField('startDate')
      } else if (!that.activity.startTime) {
        focusField('startTime')
      }
    } catch(e) {
      
    }
  }
}

export function noteRequest (that, from) {
  let note = {
    noteHeader: that.note.noteHeader,
    noteDetails: that.note.noteDetails,
    customer: that.note.customer,
    contact: that.note.contact,
    opportunity: that.note.opportunity
  };
  
  if (that.note.custNoteId) {
    note.custNoteId = that.note.custNoteId
  }
  if (that.note.customer && that.note.customer.customerId) {
    note.customer = that.note.customer.customerId
  }
  if (that.note.contact && that.note.contact.contactId) {
    note.contact = that.note.contact.contactId
  }
  if (that.note.assignFor && that.note.assignFor.id) {
    note.assignFor = that.note.assignFor.id
  }
  if (that.note.opportunity && that.note.opportunity.oppId) {
    note.opportunity = that.note.opportunity.oppId
  }
  delete that.note.createdBy
  delete that.note.updatedBy

  if (Array.isArray(that.note.noteTags)) {
    let a = []
    that.note.noteTags.forEach(tag => {
      if (tag && tag.id) {
        a.push({
          "tagId": tag.id
        })
      }
    })
    note.noteTags = a
  }

  
  
  if (
    note.customer
    && note.noteHeader
  ) {
  
    if (note.custNoteId) {
      
      that.customerService
        .updateNoteDB(note.custNoteId, note)
        .then((response) => {
          that.sendingRequest = false
  
          that.$toast.add({
            severity: "success",
            summary: response.data,
            detail: "Note Updated",
            life: 5000,
          });
  
          if (from === 'NoteForm.vue') {
            that.$emit('noteSaved')
            that.note = {}
          }
        })
        .catch((e) => {
          that.sendingRequest = false
          
  
          if (e.response && e.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating note",
              life: 5000,
            })
        });
    } else {
      
      that.customerService
        .saveNoteDB(note)
        .then((response) => {
          that.sendingRequest = false
  
          that.$toast.add({
            severity: "success",
            summary: response.data,
            detail: "New Note Saved",
            life: 5000,
          });
  
          if (from === 'NoteForm.vue') {
            that.$emit('noteSaved')
            that.note = {}
          }
        })
        .catch((e) => {
          that.sendingRequest = false
  
          
  
          if (e.response && e.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving note",
              life: 5000,
            })
        });
    }
  } else {
    that.sendingRequest = false
    
    try {
      if (!that.note.noteHeader) {
        document.getElementById('noteHeader').focus()
      } else if (!that.note.customer) {
        document.getElementById('customer').focus()
      }
    } catch(e) {
      
    }
  }
}

export function attachmentRequest (that, from) {

  var newAttachment = {...that.attachment}
        
  let obj = {
    fileName: that.file.name,
    fileLocation: "",
    attachDesc: newAttachment.attachDesc
  };
  if (Array.isArray(newAttachment.attachTags)) {
    let a = newAttachment.attachTags.map(tag => {
      return {
        'tagId': tag.id
      }
    })
    newAttachment.attachTags = a
    obj.attachTags = a
  }

  if (that.customer && that.customer.customerId) {
    newAttachment.customer = that.customer.customerId
    obj.customer = that.customer.customerId
  } else if (that.quotation && that.quotation.customer && that.quotation.customer.customerId) {
    newAttachment.customer = that.quotation.customer.customerId
    obj.customer = that.quotation.customer.customerId
  } else if (newAttachment && newAttachment.customer && newAttachment.customer.customerId) {
    newAttachment.customer = newAttachment.customer.customerId
    obj.customer = newAttachment.customer.customerId
  } else {
    newAttachment.customer = null
    obj.customer = null
  }
  delete newAttachment.createdBy
  delete newAttachment.updatedBy

  if (that.quotation && that.quotation.quoteVerId) {
    newAttachment.quotation = that.quotation.quoteVerId
    obj.quotation = that.quotation.quoteVerId
  } else if (that.thisQuotation && that.thisQuotation.quoteVerId) {
    newAttachment.quotation = that.thisQuotation.quoteVerId
    obj.quotation = that.thisQuotation.quoteVerId
  }
  
  

  if (newAttachment.attachId) {
    
    that.attachmentService
      .putAttachment(newAttachment.attachId, newAttachment)
      .then((res) => {
        that.sendingRequest = false
        that.$toast.add({
          severity: "success",
          summary: res.data.fileName + ' uploaded successfully',
          detail: "File uploaded",
          life: 5000,
        });
        
        if (from === 'attachmentForm.vue') {
          that.$emit('saved', { file: that.file, attachment: that.thisAttachment, quotation: that.thisQuotation })
        }

      })
      .catch((err) => {
        that.sendingRequest = false
        

        if (err.response && err.response.status !== 200)                
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating attachment",
            life: 5000,
          })
      });
  } else {
    if (that.file) {
      
      that.attachmentService
        .postFile(that.file, obj, that)
        .then((res) => {
          that.sendingRequest = false
          that.$toast.add({
            severity: "success",
            summary: res.data.fileName + ' uploaded successfully',
            detail: "File uploaded",
            life: 5000,
          });
        
          if (from === 'attachmentForm.vue') {
            that.$emit('saved', { file: that.file, attachment: that.thisAttachment, quotation: that.thisQuotation })
          }

        })
        .catch((err) => {
          that.sendingRequest = false
          

          if (err && err.response && err.response.data) {
            if (err.response.data.includes("exceeds the configured maximum")) {
              that.$toast.add({
                severity: "error",
                summary: "File too big.",
                detail: "File size exceeds the limited size.",
                life: 5000,
              });
            }
          }

        });
    }
  }
}

export function tagRequest (that, from) {

  var newTag = {...that.tag}

  if (
    newTag &&
    newTag.tag &&
    newTag.type
  ) {
    if (newTag.active && newTag.active.value) {
      newTag.active = newTag.active.value
    } else {
      newTag.active = false
    }
    if (newTag.type && newTag.type.name) {
      newTag.type = newTag.type.name
    }

    
    if (newTag.id) {
      // PUT
      that.tagsService
        .updateTag(newTag)
        .then((res) => {
          that.sendingRequest = false
          that.$toast.add({
            severity: "success",
            summary: res.data,
            detail: "Tag updated",
            life: 5000,
          });
          
          if (from === 'tagForm.vue') {
            that.$emit('save', newTag)
          }

        })
        .catch((err) => {
          that.sendingRequest = false
          

          if (err.response && err.response.status !== 200)                
            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating tag",
              life: 5000,
            })
        });
    } else {
      // POST
      
      that.tagsService
      .saveTag(newTag)
      .then((res) => {
        that.sendingRequest = false
        that.$toast.add({
          severity: "success",
          summary: res.data,
          detail: "Tag saved",
          life: 5000,
        });
        
        if (from === 'tagForm.vue') {
          that.$emit('save', newTag)
        }

      })
      .catch((err) => {
        that.sendingRequest = false
        

        if (err.response && err.response.status !== 200)                
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving tag",
            life: 5000,
          })
      });
    }
  }
}

export function filterSaveRequest (that, from) {

  var filters = [...that.filters]
  
  
  that.filterDetails.whereClause = ''
  filters.forEach((filter, index) => {
    

    let a = that.filters2.findIndex(a => a.id === filter.dbField)
    
    if (a >= 0) {
      let b = that.filters4Data[a]
      
      if (b && Array.isArray(b)) {
        let c
        if (that.filters2[a].dbNameField) {
          c = that.filters2[a].dbNameField.split('.')
        } else {
          c = that.filters2[a].dbField.split('.')
        }
        
        if (c) {
          let d = {}
          if (that.filters2[a].fieldType === "Date") {
            d = b.find(e => e.dateModifierFunc === filter.value)
            // 
            if (d) {
              filter.dbValue = d.id
              filter.typeofValue = "string"
            }
          } else {
            d = b.find(e => e[c[c.length - 1]] === filter.value)
            
            if (d) {
              
              filter.dbValue = d[that.filters2[a].dbIdField]
              filter.typeofSelection = "object" // only for 1 purpose but can be expanded
            }
          }
        } else {
          let d = {}
          if (that.filters2[a].fieldType === "Date") {
            d = b.find(e => e.dateModifierFunc === filter.value)
            // 
            if (d) {
              filter.dbValue = d.id
            }
          } else {
            d = b.find(e => e[that.filters2[a].dbField] === filter.value)
            if (d) {
              filter.dbValue = d[that.filters2[a].dbIdField]
            }
          }
        }
      }
    }

    // var fieldForWhereClause = '', valueForWhereClause = null;

    // 
    // if (
    //   (
    //     filter.field === 'createdBy.fullName' ||
    //     filter.field === 'updatedBy.fullName' ||
    //     filter.field === 'contact.contactName'
    //   ) &&
    //   filter.filter2 && 
    //   filter.filter2.id
    // ) {

    //   // 
         
    //   if (filter.field === 'createdBy.fullName') {
    //     fieldForWhereClause = 'createdBy.id'
    //     let a = that.users.find(b => b.fullName === filter.value) // Same lines are duplicate but will be run only 3 times, if they were out, they would run more times
    //     if (a) {
    //       valueForWhereClause = a.id
    //     }

    //   } else if (filter.field === 'updatedBy.fullName') {
    //     fieldForWhereClause = 'updatedBy.id'
    //     let a = that.users.find(b => b.fullName === filter.value)
    //     if (a) {
    //       valueForWhereClause = a.id
    //     }
        
    //   } else if (filter.field === 'contact.contactName') {
    //     fieldForWhereClause = 'contact.contactId'
    //     let a = that.contacts.find(b => b.fullName === filter.value)
    //     
    //     if (a) {
    //       valueForWhereClause = a.contactId
    //     }
        
    //   }

    // } else {
    //   if (filter.filter2) {
    //     if (filter.filter2.dbFilterField && filter.typeofSelection && filter.typeofSelection === 'object') {
    //       fieldForWhereClause = filter.filter2.dbFilterField
    //     } else {
    //       fieldForWhereClause = filter.filter2.dbField
    //     }
    //   } else {
    //     fieldForWhereClause = filter.field
    //   }
    //   if (filter.value !== null)
    //     valueForWhereClause = filter.value
    // }

    // 
    // let valueParts = 1
    // try {
    //   valueParts = valueForWhereClause.split('/')
    // } catch(e) {}

    // if (index !== 0 && filter.gate && filter.comparison && filter.field && filter.value !== null) {
    //   if (valueForWhereClause === 'Yes') {
    //     that.filterDetails.whereClause = that.filterDetails.whereClause.concat(` ${filter.gate} ${fieldForWhereClause} ${filter.comparison} true`)
    //   } else if (valueForWhereClause === 'No') {
    //     that.filterDetails.whereClause = that.filterDetails.whereClause.concat(` ${filter.gate} ${fieldForWhereClause} ${filter.comparison} false`)
    //   } else if (typeof valueForWhereClause === 'number') {
    //     that.filterDetails.whereClause = that.filterDetails.whereClause.concat(` ${filter.gate} ${fieldForWhereClause} ${filter.comparison} ${valueForWhereClause}`)
    //   } else {
    //     if (filter && filter.filter2 && filter.filter2.fieldType === 'Date' && valueParts.length !== 3) {
    //       that.filterDetails.whereClause = that.filterDetails.whereClause.concat(` ${filter.gate} ##DATE-MOD##${fieldForWhereClause}##${filter.comparison}##MOD-TYPE##${valueForWhereClause}##`)
    //       filter.dbValue = `##DATE-MOD##${fieldForWhereClause}##${filter.comparison}##MOD-TYPE##${valueForWhereClause}##`
    //     } else {
    //       that.filterDetails.whereClause = that.filterDetails.whereClause.concat(` ${filter.gate} ${fieldForWhereClause} ${filter.comparison} '${valueForWhereClause}'`)
    //     }
    //   }

    // } else if (index === 0 && filter.comparison && filter.field && filter.value !== null) {
    //   
    //   if (valueForWhereClause === 'Yes') {
    //     that.filterDetails.whereClause = that.filterDetails.whereClause.concat(`${fieldForWhereClause} ${filter.comparison} true`)
    //   } else if (valueForWhereClause === 'No') {
    //     that.filterDetails.whereClause = that.filterDetails.whereClause.concat(`${fieldForWhereClause} ${filter.comparison} false`)
    //   } else if (typeof valueForWhereClause === 'number') {
    //     that.filterDetails.whereClause = that.filterDetails.whereClause.concat(`${fieldForWhereClause} ${filter.comparison} ${valueForWhereClause}`)
    //   } else {
    //     if (filter && filter.filter2 && filter.filter2.fieldType === 'Date' && valueParts.length !== 3) {
    //       that.filterDetails.whereClause = that.filterDetails.whereClause.concat(`##DATE-MOD##${fieldForWhereClause}##${filter.comparison}##MOD-TYPE##${valueForWhereClause}##`)
    //       filter.dbValue = `##DATE-MOD##${fieldForWhereClause}##${filter.comparison}##MOD-TYPE##${valueForWhereClause}##`
    //     } else {
    //       that.filterDetails.whereClause = that.filterDetails.whereClause.concat(`${fieldForWhereClause} ${filter.comparison} '${valueForWhereClause}'`)
    //     }
    //   }
    // }
    // 
  })  

  
  // A filter with no condition rows constrains nothing: it saves happily and then returns
  // the whole table. 43 filters on live are in that state, one of them somebody's default
  // view. The guard that used to be here checked whereClause, which the front end stopped
  // building - the server compiles it from the conditions now - so it checks the rows.
  var usableConditions = filters.filter(function (filter) {
    return filter && filter.dbField
  })

  if (
    that.filterDetails.filterName &&
    usableConditions.length > 0
  ) {
    if (that.filterDetails.dbview === null || that.filterDetails.dbview === undefined) {
      that.filterDetails.dbview = 1
    }

    if (that.filterDetails.user && that.filterDetails.user.id) {
      that.filterDetails.user = that.filterDetails.user.id
    } else {
      that.filterDetails.user = that.$store.getters['auth/getMyProfile'].id
    }

    that.filterDetails.conditions = []
    filters.forEach(async (filter, index) => {
      
      let b = {}

      if (index > 0) {
        b.rowStart = filter.gate
        b.dbField = filter.dbField
        b.condition = filter.comparison
        b.value = filter.value
        b.dbValue = filter.dbValue
        b.rowNo = index + 1

      } else {
        b.dbField = filter.dbField
        b.condition = filter.comparison
        b.value = filter.value
        b.dbValue = filter.dbValue
        b.rowNo = index + 1
      }

      that.filterDetails.conditions.push(b)
    })

    if (that.filterDetails.id) {
      // Update
      that.filtersService
      .putUserViewFilter(that.filterDetails)
      .then(response => {
        
        that.$toast.add({
          severity: "success",
          summary: "Filter Updated Successfully",
          detail: `The filter ${that.filterDetails.filterName} was updated successfully. You can also set it as default to open when you load the view.`,
          life: 5000,
        });

        that.filtersService
          .setSavedFilterFav(response, that.favorite ? 1 : 0)
          .then(data => {
            
          })
          .catch(error => {
            that.$toast.add({
              severity: "error",
              summary: "Can't change favorite...",
              detail: "Error while changing favorite status of this filter.",
              life: 5000,
            })
          })

        if (from === 'filterForm.vue') {
          that.$emit('saved')
        }

      })
      .catch(err => {
        that.sendingRequest = false
        

        if (err.response && err.response.status !== 200)
          that.$toast.add({
            severity: "error",
            summary: "Error",
            // The server rejects a filter with no conditions with a message the user can
            // act on; show it rather than a generic string.
            detail: (err.response.data && typeof err.response.data === 'string')
              ? err.response.data
              : "Error while updating userViewFilter",
            life: 5000,
          })
          
      })

    } else {
      // Save
      delete that.filterDetails.id
      
      that.filtersService
      .postUserViewFilter(that.filterDetails)
      .then(response => {
        
        that.$toast.add({
          severity: "success",
          summary: "Filter Saved Successfully",
          detail: `The filter ${that.filterDetails.filterName} was saved successfully. You can now select this filter from the filter dropdown list. You can also set as default to open when you load the view.`,
          life: 5000,
        });

        if (that.favorite) {
          that.filtersService
            .setSavedFilterFav(response, 1)
            .then(data => {
              
            })
            .catch(error => {
              that.$toast.add({
                severity: "error",
                summary: "Can't change favorite...",
                detail: "Error while changing favorite status of this filter.",
                life: 5000,
              })
            })

        }
        
        if (from === 'filterForm.vue') {
          that.$emit('saved')
        }
      })
      .catch(err => {
        that.sendingRequest = false
        

        if (err.response && err.response.status !== 200)
          that.$toast.add({
            severity: "error",
            summary: "Error",
            // The server rejects a filter with no conditions with a message the user can
            // act on; show it rather than a generic string.
            detail: (err.response.data && typeof err.response.data === 'string')
              ? err.response.data
              : "Error while saving userViewFilter",
            life: 5000,
          })
          
      })
    }
  } else {
    // Previously this branch was silent, so pressing Save with nothing filled in looked
    // like the app had simply ignored the click.
    that.sendingRequest = false
    that.$toast.add({
      severity: "warn",
      summary: that.filterDetails.filterName ? "Add a condition" : "Name the filter",
      detail: that.filterDetails.filterName
        ? "A filter needs at least one condition, otherwise it returns every record."
        : "Give the filter a name before saving it.",
      life: 5000,
    })
  }
}

export function columnSelectionRequest (that, from) {

  that.filtersService
  .deleteCurrentUserViewFields(that.dbView)
  .then(data => {
    
    // 
    
    var len = that.selected.length - 1
    that.selected.forEach((a, index) => {
      
      var obj = {
        dbView: that.dbView,
        dbField: a.id,
        colOrder: index + 1,
        width: Math.round((a.width / 100) * 300)
      }
      
      
      that.filtersService
        .saveColumnSelection(obj)
        .then(data => {
          

          if (index === len) {
            that.sendingRequest = false
            if (
              from === 'columnSelection.vue' ||
              from === 'ActivityTableForLazyLoadingWithResize.vue' ||
              from === 'QuotationTableForLazyLoadingWithResize.vue' ||
              from === 'OpportunityTableForLazyLoadingWithResize.vue' ||
              from === 'ContactsTableForLazyLoadingWithResize.vue' ||
              from === 'CustomersDataTableForLazyWithResize.vue'
            ) {
              that.$emit('colSaved')
            } else if (
              from === 'Quotation-Table.vue' ||
              from === 'Customers.vue'
            ) {
              that.getColumnSelectionByHard()
              that.getDBViewFields()
            } else if (
              from === 'ActivitiesDataTable.vue' ||
              from === 'ContactsTable.vue' ||
              from === 'CustomersDataTable'
            ) {
              that.$emit('reloadCols')
            }
          }

        })
        .catch(err => {
          that.sendingRequest = false
          
                
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving selection",
            life: 5000,
          })
          

          if (index === len) {
            that.sendingRequest = false

            if (from === 'columnSelection.vue') {
              that.$emit('colSaved')
            } else if (
              from === 'Opportunity.vue' ||
              from === 'Quotation-Table.vue' ||
              from === 'Customers.vue'
            ) {
              that.getColumnSelection()
              that.getDBViewFields()
            } else if (
              from === 'ActivitiesDataTable.vue' ||
              from === 'ContactsTable.vue' ||
              from === 'CustomersDataTable'
            ) {
              that.$emit('reloadCols')
            }
          }
        })

    })
  })
  .catch(err => {
    that.sendingRequest = false
    

    if (err.response && err.response.status !== 200)  
      that.$toast.add({
        severity: "error",
        summary: "Error",
        detail: "Error while updating selection",
        life: 5000,
      })
  })

}

export function customerGroup (that, from) {
  if (that.account) {

    if (that.account.mainBranch === undefined || that.account.mainBranch === null) {
      that.account.mainBranch = false
    }
    if (that.account.active === undefined || that.account.active === null) {
      that.account.active = true
    }

    var accountToBeSent = {...that.account}

    if (that.customer && that.customer.customerId) {
      accountToBeSent.customerId = that.customer.customerId
    }
    if (that.customerId && that.customerId.customerId) {
      accountToBeSent.customerId = that.customerId.customerId
    }
    if (that.account.mbpBranch && that.account.mbpBranch.id) {
      accountToBeSent.mbpBranch = that.account.mbpBranch.id
    }
    if (that.account.salesExec && that.account.salesExec.id) {
      accountToBeSent.salesExec = that.account.salesExec.id
    }
  
    if (
      accountToBeSent.customerId &&
      accountToBeSent.tasCode &&
      accountToBeSent.mbpBranch &&
      accountToBeSent.salesExec
    ) {
      if (accountToBeSent.id) {
        that.sendingRequest = false

      } else {
        that.customerService
          .saveCustomerGroupAccount(accountToBeSent.customerId, accountToBeSent)
          .then(data => {
            that.sendingRequest = false

        
            if (from === 'AccountForm.vue') {
              that.$emit('saved', accountToBeSent)
            }
          })
          .catch(error => {
            that.sendingRequest = false

            that.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving Customer group.",
              life: 5000,
            })
          })

      }
    } else {
      that.sendingRequest = false

      
      try {
        if (!that.account.customerId) {
          document.getElementById('customer').focus()
        } else if (!that.account.tasCode) {
          document.getElementById('tasCode').focus()
        } else if (!that.account.mbpBranch) {
          document.getElementById('mbpBranch').focus()
        } else if (!that.account.salesExec) {
          document.getElementById('salesExec').focus()
        }
      } catch(e) {
        
      }
    }
  }
}

export function customerMBPBranch (that, from) {
  if (that.account && that.customer && that.customer.customerId) {

    if (
      (
        that.account.active &&
        (
          that.account.branchId ||
          that.account.mainBranchId ||
          (
            that.account.mbpBranch &&
            that.account.mbpBranch.id
          )
        ) &&
        that.account.salesExec &&
        that.account.salesExec.id
      ) ||
      !that.account.active
    ) {
      let accountToBeSent = {
        mbpBranch: that.account.branchId || that.account.mainBranchId,
        tasCode: '',
        salesExec: that.account.salesExec,
        custBranchId: that.account.custBranchId,
        mainBranch: that.account.mainBranch,
        active: that.account.active
      }
      if (that.account.tasCode) {
        accountToBeSent.tasCode = that.account.tasCode
      }
      if (accountToBeSent.mbpBranch && accountToBeSent.mbpBranch.id) {
        accountToBeSent.mbpBranch = accountToBeSent.mbpBranch.id
      }
      if (accountToBeSent.salesExec && accountToBeSent.salesExec.id) {
        accountToBeSent.salesExec = accountToBeSent.salesExec.id
      }

      that.customerService
        .addCustomerMBPBranch(that.customer.customerId, accountToBeSent)
        .then(data => {
          that.sendingRequest = false

      
          if (from === 'AccountForm.vue') {
            that.$emit('saved', accountToBeSent)
          }
        })
        .catch(error => {
          that.sendingRequest = false
          let index = -1, a = 'java.lang.RuntimeException: ';
          if (error.response.data) {
            index = error.response.data.indexOf(a)
          }
          if (index < 0) {
            that.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "v1/addCustomerMBPBranch/{customerId}"'
            })
          } else {
            that.$toast.add({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data.substr(index + a.length, error.response.data.length - 1),
              life: 5000,
            })
          }
        })

    } else {
      that.sendingRequest = false

      
      try {
        if (!
          (
            that.account.branchId ||
            that.account.mainBranchId ||
            (
              that.account.mbpBranch &&
              that.account.mbpBranch.id
            )
          )
        ) {
          document.getElementById('mbpBranch').focus()
        } else if (!that.account.salesExec) {
          document.getElementById('salesExec').focus()
        }
      } catch(e) {
        
      }
    }


  }
}

export function changeEmail (that, from) {
  var user = {...that.userToEdit}

  that.userService
    .updateUserEmail(user.userId, {newEmail: that.newEmail})
    .then((data) => {
      that.sendingRequest = false
      if (from === 'ChangeEmailForm.vue') {
        that.$emit('updated', {
          ...that.user,
          email: that.newEmail
        })
        that.newEmail = ''
        that.confirmEmail = ''
        that.invalidNewEmail = false
        that.invalidConfirmEmail = false
        that.submitted = false
      }
    })
    .catch((e) => {
      that.sendingRequest = false
      if (e.response.status !== 200) {
        that.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error while updating the email address. Ensure that the new email address is not already used by another user.",
          life: 5000,
        })
      }
    });

}

export function sendUser (that, from) {
  
  if (that.user) {
    var user = { ...that.user }

    

    if (user.supervisor && user.supervisor.id) {
      user.supervisor = user.supervisor.id
    }
    if (user.mbpDept && user.mbpDept.id) {
      user.mbpDept = user.mbpDept.id
    }
    if (user.defRegion && user.defRegion.id) {
      user.defRegion = user.defRegion.id
    }
    if (user.defBranch && user.defBranch.id) {
      user.defBranch = user.defBranch.id
    }
    if (user.defProdType && user.defProdType.id) {
      user.defProdType = user.defProdType.id
    }
    // if (user.status && user.status.statusName) {
    //   user.status = user.status.statusName
    // }
    if (user.salesExec && user.salesExec.id) {
      user.salesExec = user.salesExec.id
    }
    if (user.role && user.role.id) {
      user.role = user.role.id
    }

    if (!user.email) {
      that.sendingRequest = false
      document.getElementById('email').focus()
      return
    }
    if (!user.firstName) {
      that.sendingRequest = false
      document.getElementById('firstName').focus()
      return
    }
    if (!user.lastName) {
      that.sendingRequest = false
      document.getElementById('lastName').focus()
      return
    }
    if (!user.role) {
      that.sendingRequest = false
      document.getElementById('role').focus()
      return
    }

    delete user.status
    delete user.salesExec
    delete user.fullName

    
    

    if (user.id) {
      that.userService
        .updateAUser({
          id: user.id,
          firstName: user.firstName,
          lastName: user.lastName,
          mbpDept: user.mbpDept,
          supervisor: user.supervisor,
          defRegion: user.defRegion,
          defBranch: user.defBranch,
          role: user.role,
          getReminderEmail: user.getReminderEmail,
          getNotesEmail: user.getNotesEmail,
          getCustApproveEmail: user.getCustApproveEmail,
          createOutlookActivity: user.createOutlookActivity
        })
        .then(data => {
          that.sendingRequest = false

          if (from === 'UserForm.vue') {
            that.$emit('updated', {
              ...that.user,
              fullName: `${that.user.firstName} ${that.user.lastName}`
            })
          }
        })
        .catch(error => {
          that.sendingRequest = false
          
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while updating user`,
            life: 5000,
          })
        })

    } else {
      
      that.userService
        .register({
          email: user.email,
          password: `${user.firstName}@01${user.lastName}${new Date().getTime()}`,
          returnSecureToken: true
        })
        .then(registerData => {
          

          that.userService
            .completeSignupWithToken(user, registerData.idToken)
            .then(completeSignupData => {

              if (completeSignupData.data && completeSignupData.data.id) {
                that.userService
                  .updateUser({
                    ...user,
                    id: completeSignupData.data.id
                  })
                  .then(updateUserData => {
                    
  
                    that.userService
                      .sendResetPasswordEmail({
                        requestType: 'PASSWORD_RESET',
                        email: user.email
                      })
                      .then(sendResetPasswordEmailData => {
                        
                        that.sendingRequest = false
  
                        if (from === 'UserForm.vue') {
                          that.$emit('saved', {
                            registerData,
                            completeSignupData: completeSignupData.data,
                            updateUserData,
                            sendResetPasswordEmailData
                          })
                        }
                      })
                      .catch(error => {
                        that.sendingRequest = false
  
                        
                      })
          
                  })
                  .catch(error => {
                    that.sendingRequest = false
                    
                  })
              } else {
                that.sendingRequest = false

              }

    
            })
            .catch(error => {
              that.sendingRequest = false
              
              
            })

        })
        .catch(error => {
          that.sendingRequest = false
          
          

          if (error && error.response && error.response.data && error.response.data.error && error.response.data.error.message === 'EMAIL_EXISTS') {
            that.$toast.add({
              severity: "error",
              summary: "Duplicate email",
              detail: "Email already exists.",
              life: 5000,
            })
          }
        })
    }
  }
}

export function widgetRequest (that, from) {

  if (
    that.widget
    && that.widget.id
    && that.widgetTitle
    && that.screenPos
    && (
      (
        that.widget.widgetParam1
        && that.ParamVal1
        && that.ParamVal1.length
      ) 
      || (
        !that.widget.widgetParam1
        && true
      )
    )
    && (
      (
        that.widget.widgetParam2
        && that.ParamVal2
        && that.ParamVal2.length
      ) 
      || (
        !that.widget.widgetParam2
        && true
      )
    )
    && (
      (
        that.widget.widgetParam3
        && that.ParamVal3
        && that.ParamVal3.length
      ) 
      || (
        !that.widget.widgetParam3
        && true
      )
    )
    && (
      (
        that.widget.widgetParam4
        && that.ParamVal4
        && that.ParamVal4.length
      ) 
      || (
        !that.widget.widgetParam4
        && true
      )
    )
    && that.user
    && that.user.id
  ) {

    let obj = {
      widget: that.widget.id,
      widgetName: that.widgetTitle,
      screenPos: that.screenPos,
      widgetType: that.widget.widgetType,
      user: that.user.id
    }

    if (that.activeOption && that.activeOption.name) {
      obj.active = that.activeOption.value
    }

    if (that.dbView && that.dbView.id && that.savedFilter && that.savedFilter.id) {
      obj.viewId = that.dbView.id
      obj.userViewFilterId = that.savedFilter.id
    } else if (that.report && that.report.id) {
      obj.report = that.report.id
    }
    
    if (that.ParamVal1 && that.ParamVal1.length) {
      let a = ''
      that.ParamVal1.forEach(val => {
        a = a.concat(`,${val.id}`)
      })
      obj.ParamVal1 = a.substr(1)
    }
    if (that.ParamVal2 && that.ParamVal2.length) {
      let a = ''
      that.ParamVal2.forEach(val => {
        a = a.concat(`,${val.id}`)
      })
      obj.ParamVal2 = a.substr(1)
    }
    if (that.ParamVal3 && that.ParamVal3.length) {
      let a = ''
      that.ParamVal3.forEach(val => {
        a = a.concat(`,${val.id}`)
      })
      obj.ParamVal3 = a.substr(1)
    }
    if (that.ParamVal4 && that.ParamVal4.length) {
      let a = ''
      that.ParamVal4.forEach(val => {
        a = a.concat(`,${val.id}`)
      })
      obj.ParamVal4 = a.substr(1)
    }

    
    
    that.sendingRequest = true

    if (that.widgetToEdit && that.widgetToEdit.id) {
      that.userService
        .updateUserWidget(that.widgetToEdit.id, obj)
        .then(data => {
          that.sendingRequest = false

          if (from === 'WidgetForm.vue') {
            that.$emit('updated', {
              ...obj,
              id: that.widgetToEdit.id
            })
          }
        })
        .catch(error => {
          that.sendingRequest = false
          
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while updating widget`,
            life: 5000,
          })
        })

    } else {
      that.userService
        .saveUserWidget(obj)
        .then(data => {
          that.sendingRequest = false

          if (from === 'WidgetForm.vue') {
            that.$emit('saved', obj)
          }
        })
        .catch(error => {
          that.sendingRequest = false
          
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while saving widget`,
            life: 5000,
          })
        })
      
    }
  }
}

export function copyUserWidgetData (that, from) {
  let users = [...that.users]
  let valPass = 0
  if(that.users.length <= 0) 
  {
    that.sendingRequest = false
    return
  }

  users.forEach((user)=>{
    that.userService
    .copyUserWidgetData(that.user.userId, user.id)
    .then(data => {
      valPass++
      if (from === 'DuplicateWidgetForm.vue' && users.length === valPass) {
        that.sendingRequest = false
        that.$emit('updated', that.user)
        that.users = []
        that.submitted = false
      }
     
    })
    .catch(error => {
      that.sendingRequest = false
      if (error.response.status !== 200) {
        that.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error while copying widgets.",
          life: 5000,
        })
      }
    })
  })


}

export function sendRole (that, from) {
  
  if (that.role) {
    var role = { ...that.role }


    if (!role.roleName) {
      that.sendingRequest = false
      document.getElementById('roleName').focus()
      return
    }

    delete role.createdBy
    delete role.createdById
    delete role.createdByName
    delete role.updatedBy
    delete role.createdById
    delete role.updatedByName


    if (role.id) {
      that.roleService
        .updateRole({
          id: role.id,
          roleName: role.roleName,
          active: role.active,
          showAdmin: role.showAdmin,
          showSettings: role.showSettings,
        })
        .then(data => {
          that.sendingRequest = false

          if (from === 'RolesForm.vue') {
            that.$emit('updated', that.role)
          }
        })
        .catch(error => {
          that.sendingRequest = false
          
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while updating role`,
            life: 5000,
          })
        })

    } else {
      that.roleService
        .saveRole({
          roleName: role.roleName,
          active: role.active,
          showAdmin: role.showAdmin,
          showSettings: role.showSettings,
        })
        .then(data => {
          that.sendingRequest = false

          if (from === 'RolesForm.vue') {
            that.$emit('saved', that.role)
          }
        })
        .catch(error => {
          that.sendingRequest = false
          
          that.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while saving role`,
            life: 5000,
          })
        })

    }
  }
}

export function sendPermission (that, from) {
  var per = null
  if(that.permissions && that.selectedRow) {
    per = that.permissions.find(p => p.permission && p.permission.permissionCode === that.selectedRow.permissionCode)
  }

  if (
    that.role 
    && that.role.id 
    && that.selectedRow 
    && that.permissionLevel && per
  ) {
    var payload = { 
      id: per.id,
      userOrRole: 2,
      roleId: that.role.id,
      permissionId: that.selectedRow.id,
      permissionLevel: that.permissionLevel.id
    }
      
    that.roleService
      .updatePermission(payload)
      .then(data => {
        that.sendingRequest = false

        if (from === 'PermissionsForm.vue' || from === 'PermissionsTable.vue') {
          that.$emit('saved', payload)
        }
      })
      .catch(error => {
        that.sendingRequest = false
        
        that.$toast.add({
          severity: "error",
          summary: "Error",
          detail: `Error while saving permission`,
          life: 5000,
        })
      })

  }
}